/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoPatologiaInfettivaDTO
 */
export interface AssistitoPatologiaInfettivaDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoPatologiaInfettivaDTO interface.
 */
export function instanceOfAssistitoPatologiaInfettivaDTO(value: object): value is AssistitoPatologiaInfettivaDTO {
    return true;
}

export function AssistitoPatologiaInfettivaDTOFromJSON(json: any): AssistitoPatologiaInfettivaDTO {
    return AssistitoPatologiaInfettivaDTOFromJSONTyped(json, false);
}

export function AssistitoPatologiaInfettivaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoPatologiaInfettivaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoPatologiaInfettivaDTOToJSON(value?: AssistitoPatologiaInfettivaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

